module.exports = __webpack_public_path__ + "img/bkk-bk.ea56a622.svg";